<rid-feedback-toast [title]="title()" [description]="description()" [variant]="variant()" (continued)="continued.emit()" />
